import Vue from 'vue';
import GiftCard from '@components/blocks/gift-card.vue';
import FeatureCard from '@components/blocks/feature-card.vue';
import PointerList from '@components/blocks/pointer-list.vue';
import CircleList from '@components/blocks/circle-list.vue';

// componenti e impostazioni specifiche del site
export default function site_config() {
  // i quattro block del flusso gift card ricorrono in tutte e tre le pagine
  // (acquisto, checkout, conferma): li registro globali per non ripetere gli import
  Vue.component('gift-card', GiftCard);
  Vue.component('feature-card', FeatureCard);
  Vue.component('pointer-list', PointerList);
  Vue.component('circle-list', CircleList);
}